import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/solution/real-estate-updated/strategy-back.webp";
import { Link } from "gatsby";

function Strategyrealestate() {
  return (
    <section
      className="strategy_real_estate p-100 text_white"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <span className="short_title">
              Get A Unique Customized App With TekRevol
            </span>
            <h2>
              Strategic <span>Real Estate App</span> Development Solutions for
              Every Type of Business and Stakeholders
            </h2>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 mb-md-0">
            <div className="strategy-box">
              <div className="title">01</div>
              <div className="strategy-content">
                <h5>Property Buyers</h5>
                <p>
                  Build an intuitive platform for buyers with our real estate
                  app development solutions. Enjoy effortless navigation and
                  engaging virtual tours to enhance the property-buying
                  experience.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 mb-md-0">
            <div className="strategy-box">
              <div className="title">02</div>
              <div className="strategy-content">
                <h5>Real Estate Companies and Sellers</h5>
                <p>
                  Use our real estate mobile app development services for quick
                  verification of buyers' licenses and credit histories. This
                  streamlined process boosts transaction security and builds
                  trust among all stakeholders.
                </p>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={4}
            xl={4}
            xxl={4}
            className="mt-0 mt-md-4 mt-lg-0"
          >
            <div className="strategy-box">
              <div className="title">03</div>
              <div className="strategy-content">
                <h5>For Real Estate Aggregators</h5>
                <p>
                  With our real estate app development services, Integrate your
                  real estate app with your website to showcase vibrant property
                  images and videos while offering personalized payment
                  processing.
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Request A Service!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Strategyrealestate;
